export const qualitiesPt = [
    'Mais de 35 anos de experiência',
    'Equipe capacitada',
    'Foco nas necessidades do cliente',
    'Gestão e confidencialidade'
];

export const qualitiesEng = [
    'Over 35 years of experience',
    'Skilled team',
    'Focus on customer needs',
    'Proven experience in management and confidentiality'
];
